import clsx from 'clsx';

import styles from './Avatar.module.css';

export interface AvatarProps {
  readonly initials: string;
  readonly title?: string;
  readonly size?: 'sm' | 'md';
  readonly muted?: boolean;
}

export function Avatar({ initials, title, size = 'md', muted }: AvatarProps) {
  return (
    <span
      className={clsx(styles.avatar, size === 'sm' && styles.sm, muted && styles.muted)}
      title={title}
      aria-label={title}
      role={title ? 'img' : undefined}
    >
      {initials}
    </span>
  );
}
